import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link
              to="/"
              onClick={scrollToTop}
              className="text-xl font-heading font-bold text-primary-400 inline-block mb-4"
            >
              911<span className="text-background-50">黑料</span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed">
              汇聚最全面、最真实的黑料资讯与独家爆料。揭露真相，还原事实，让每一段被掩盖的历史重见天日。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="#categories" className="hover:text-primary-400 transition-colors">热门分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    onClick={scrollToTop}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="#quick-links" className="hover:text-primary-400 transition-colors">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  onClick={scrollToTop}
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                >
                  最新爆料
                </Link>
              </li>
              <li>
                <Link
                  to="/category/yule"
                  onClick={scrollToTop}
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                >
                  娱乐圈黑料
                </Link>
              </li>
              <li>
                <Link
                  to="/category/zhengjie"
                  onClick={scrollToTop}
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                >
                  政界揭秘
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  onClick={scrollToTop}
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="#contact" className="hover:text-primary-400 transition-colors">联系我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-foreground-300">
                <i className="ri-mail-line mt-0.5 text-foreground-400"></i>
                <span>tips@yrkcpte.cn</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-300">
                <i className="ri-shield-check-line mt-0.5 text-foreground-400"></i>
                <span>爆料人身份绝对保密</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-300">
                <i className="ri-lock-line mt-0.5 text-foreground-400"></i>
                <span>PGP加密通讯可用</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 911黑料. All rights reserved. 本平台内容仅供信息参考，不构成任何建议。
          </p>
          <div className="flex items-center gap-4">
            <a href="#privacy" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#terms" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors" rel="nofollow">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}